import styled from 'styled-components';
import {JackpotBetsOptinReminderLogoDefaultBox} from './jackpot-bets-optin-reminder-logo.default.box';

export const JackpotBetsOptinReminderLogoMrgreenBox = styled(JackpotBetsOptinReminderLogoDefaultBox)`
    width: 140px;  
    height: 91.8px;
`;